import { Component, h, Prop, Watch, type EventEmitter, Event } from '@stencil/core';
import { type SortableHeader, SortOrder } from '../SearchTableConfiguration';
import arrow_down_quotes from '../assets/arrow_down_quotes.svg';
import arrow_up_quotes from '../assets/arrow_up_quotes.svg';
import sorting_unselected_quotes from '../assets/sorting_unselected_quotes.svg';
import selected_arrow_down from '../assets/selected_arrow_down.svg';
import selected_arrow_up from '../assets/selected_arrow_up.svg';
import unselected_arrow_down from '../assets/unselected_arrow_down.svg';
import unselected_arrow_up from '../assets/unselected_arrow_up.svg';

@Component({
  tag: 'uiaas-search-table-header-sorting',
  shadow: false,
  styleUrl: '../search-table.scss'
})

export class SearchTableSort {
    @Prop({ mutable: true }) sortOrder: SortOrder;
    @Prop() readonly headerName: string;
    @Prop({ mutable: false }) readonly theme: 'basic' | 'quotes';
    @Prop() readonly sortTableHeader: Array<SortableHeader> = [];
    @Event({ eventName: 'search:tableColumnSortChanged' }) tableColumnSortChanged: EventEmitter<SortableHeader>;
    @Watch('sortTableHeader')
    change():void {
        const tableHeader = this.sortTableHeader.find(x => x.fieldName === this.headerName);
        if (tableHeader){
          this.sortOrder = tableHeader.sortOrder;
          this.tableColumnSortChanged.emit({
            fieldName: this.headerName,
            sortOrder: this.sortOrder
          });
        }else{
          this.sortOrder = SortOrder.None;
        }
    }

    private sortColumn(): void{
        if(this.sortOrder !== SortOrder.None){
          this.sortOrder = this.sortOrder === SortOrder.Descending ? SortOrder.Ascending : SortOrder.Descending;
        }else{
          this.sortOrder = SortOrder.Ascending;
        }
    }

    render(): HTMLElement{
        if(this.theme === 'quotes'){
          return (<button onClick={() => this.sortColumn()} class="search-table-sorting-button">
            {this.sortOrder === SortOrder.None ?
              <span class="search-table-sorting-arrow" innerHTML={sorting_unselected_quotes}/>
              : this.sortOrder === SortOrder.Ascending ?
                <span class="search-table-sorting-arrow" innerHTML={arrow_up_quotes}/>
                :
                <span class="search-table-sorting-arrow" innerHTML={arrow_down_quotes}/>
            }
          </button>);
        }else{
          return(
            <button onClick={() => this.sortColumn()} class="search-table-sorting-button">
              {this.sortOrder === SortOrder.None ?
                <span class="tabular-sorting-arrows">
                  <span class="tabular-sorting-arrow" innerHTML={unselected_arrow_up}/>
                  <span class="tabular-sorting-arrow" innerHTML={unselected_arrow_down}/>
                </span>
                : this.sortOrder === SortOrder.Ascending ?
                  <span class="tabular-sorting-arrows">
                    <span class="tabular-sorting-arrow" innerHTML={selected_arrow_up}/>
                    <span class="tabular-sorting-arrow" innerHTML={unselected_arrow_down}/>
                  </span>
                  :
                  <span class="tabular-sorting-arrows">
                    <span class="tabular-sorting-arrow" innerHTML={unselected_arrow_up}/>
                    <span class="tabular-sorting-arrow" innerHTML={selected_arrow_down}/>
                  </span>
              }
            </button>);
        }
    }
}
